import Design, { hasDesignAnimation } from '@ui/Design/Design';
import { humanizeName } from '@utils/capitalize';
import cn from '@utils/cn';
import { TemplateWebsitePayload } from 'graphql/generated/types.autogenerated';
import { Size } from '../../components/Templates/utils/types';
import { DesignSetIdLayout } from './types';

type DesignListProps = {
  designSetLayout?: DesignSetIdLayout;
  templates?: TemplateWebsitePayload[];
  isStaticFilterSelected?: boolean;
  isGrid?: boolean;
  description?: string;
};

export default function DesignList({
  templates,
  isStaticFilterSelected,
  isGrid = true,
  designSetLayout,
  description,
}: DesignListProps) {
  if (!templates?.length) {
    return;
  }

  function renderDesign(design: TemplateWebsitePayload) {
    const sizes = design.sizes?.filter(Boolean) as Size[] | undefined;
    let hash = design.hash;
    let designTypeName = isGrid ? design.designTypeName : undefined;

    if (designSetLayout?.layout) {
      // Is design set
      designTypeName = humanizeName(designSetLayout.layout) + ' Set';
      hash = design.setHash ?? design.hash;
    }

    return (
      <Design
        designSetLayout={designSetLayout}
        sizes={sizes}
        key={design.id}
        hash={hash}
        name={design.name}
        description={description}
        designTypeName={designTypeName}
        hasAnimation={hasDesignAnimation(design, isStaticFilterSelected)}
        isStaticFilterSelected={isStaticFilterSelected}
        className={isGrid ? undefined : 'pb-8'}
      />
    );
  }

  // grid
  if (isGrid) {
    return templates.map(renderDesign);
  }

  // masonry
  return (
    <div className={cn('col-span-full columns-2 md:columns-4', 'content-center justify-center gap-8 pt-8')}>
      {templates.map(renderDesign)}
    </div>
  );
}
